import React, { PropsWithChildren } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';

type TooltipProps = {
    message: string;
    tooltipId?: string;
    className: string;
    tooltipClassName?: string;
};
const Tooltip: React.FC<PropsWithChildren<TooltipProps>> = ({
    message,
    children,
    tooltipId = 'my-tooltip',
    className = '',
    tooltipClassName = '',
}) => {
    return (
        <>
            <div
                data-tooltip-id={tooltipId}
                data-tooltip-html={message}
                data-tooltip-place="top"
                className={className}
            >
                {children}
            </div>
            <ReactTooltip id={tooltipId} className={`rounded-lg normal-case !z-[9999] ${tooltipClassName}`} />
        </>
    );
};

export default Tooltip;
